import enterView from 'enter-view';
import imagesLoaded from 'imagesloaded';

import * as AppPages from './app-pages';

export const tabletBP = 800;
export const touchMoveClasses = 'touchmove  pointermove  MSPointerMove';
export let winW = window.innerWidth;
export let browserDetection = {};
export let stateObj = {
    time: Date.now(),
};

let winResizeThrottle;

export function getScrollTop() {
    const supportPageOffset = window.pageXOffset !== undefined,
        isCSS1Compat = (document.compatMode || '') === 'CSS1Compat';

    return supportPageOffset
        ? window.pageYOffset
        : isCSS1Compat
        ? document.documentElement.scrollTop
        : document.body.scrollTop;
}

export function animateInViewEls(selector, inViewClass, offset) {
    enterView({
        selector: selector,
        offset: offset,
        once: true,
        enter: el => {
            if (el.dataset.watchdelay) {
                // Add class after delay period
                setTimeout(() => {
                    el.classList.add(inViewClass);
                }, parseFloat(el.dataset.watchdelay));
            } else {
                // Add class immediately
                el.classList.add(inViewClass);
            }
        },
    });
}

export function scrollToTarget(selector, offsetY = 0) {
    const triggers = document.querySelectorAll(selector);

    triggers.forEach(el => {
        el.addEventListener('click', e => {
            e.preventDefault();

            // Get the target elements
            const targetEl = document.querySelector(el.dataset.target),
                targetElOffsetTop = targetEl.offsetTop;

            window.scroll({
                top: targetElOffsetTop - offsetY,
                left: 0,
                behavior: 'smooth',
            });
        });
    });
}

export function autoScrollToTarget(selector, offsetY = 0) {
    // Get the target element
    const targetEl = document.querySelector(selector),
        targetElOffsetTop = targetEl.offsetTop;

    window.scroll({
        top: targetElOffsetTop - offsetY,
        left: 0,
        behavior: 'smooth',
    });
}

export function autoScrollToElement(targetEl, offsetY = 0) {
    // Get the target element
    const targetElOffsetTop = targetEl.offsetTop;
    const headerHeight = document.querySelector('.js-header').clientHeight;

    window.scroll({
        top: targetElOffsetTop - headerHeight - offsetY,
        left: 0,
        behavior: 'smooth',
    });
}

export function buildPage() {
    const content = document.querySelector('.js-content');
    // imagesLoaded(content, showPage);
    showPage();
}

export function showPage() {
    const body = document.querySelector('body');

    // Auto scroll to results on search results page
    if (document.querySelector('.js-search-results')) {
        setTimeout(() => {
            autoScrollToTarget('.js-search-results', 30);
        }, 1000);
    }

    // If we have a hash in the URL on load try to find it and auto-scroll to that section
    if (window.location.hash) {
        let target = document.getElementById(window.location.hash.substring(1));

        if (target) {
            setTimeout(() => {
                autoScrollToElement(target, 200);
            }, 1500);
        }
    }

    // Run timing function to watch for elements that have
    // animations to run when within the viewport
    // body.addEventListener('transitionend', Utilities.buildTimingFunctions);
    // setTimeout(function() {
    // body.classList.add('hide-loader');
    animateInViewEls('.js-watch', 'in-view', 0.075);
    // }, 700);
}

export function unloadPage(goTo) {
    const body = document.querySelector('body');

    body.classList.add('page-unload');

    setTimeout(() => {
        window.location = goTo;
    }, 500); // should equal page-unload CSS transition time
}

export function slideUp(target, duration = 500) {
    target.style.transitionProperty = 'height, margin, padding';
    target.style.transitionDuration = duration + 'ms';
    target.style.boxSizing = 'border-box';
    target.style.height = target.offsetHeight + 'px';
    target.offsetHeight;
    target.style.overflow = 'hidden';
    target.style.height = 0;
    target.style.paddingTop = 0;
    target.style.paddingBottom = 0;
    target.style.marginTop = 0;
    target.style.marginBottom = 0;

    window.setTimeout(() => {
        target.style.display = 'none';
        target.style.removeProperty('height');
        target.style.removeProperty('padding-top');
        target.style.removeProperty('padding-bottom');
        target.style.removeProperty('margin-top');
        target.style.removeProperty('margin-bottom');
        target.style.removeProperty('overflow');
        target.style.removeProperty('transition-duration');
        target.style.removeProperty('transition-property');
    }, duration);
}

export function slideDown(target, duration = 500) {
    target.style.removeProperty('display');
    let display = window.getComputedStyle(target).display;

    if (display === 'none') {
        display = 'block';
    }

    target.style.display = display;

    let height = target.offsetHeight;

    target.style.overflow = 'hidden';
    target.style.height = 0;
    target.style.paddingTop = 0;
    target.style.paddingBottom = 0;
    target.style.marginTop = 0;
    target.style.marginBottom = 0;
    target.offsetHeight;
    target.style.boxSizing = 'border-box';
    target.style.transitionProperty = 'height, margin, padding';
    target.style.transitionDuration = duration + 'ms';
    target.style.height = height + 'px';
    target.style.removeProperty('padding-top');
    target.style.removeProperty('padding-bottom');
    target.style.removeProperty('margin-top');
    target.style.removeProperty('margin-bottom');

    window.setTimeout(() => {
        target.style.removeProperty('height');
        target.style.removeProperty('overflow');
        target.style.removeProperty('transition-duration');
        target.style.removeProperty('transition-property');
    }, duration);
}

export function browserCheck() {
    var nUA = navigator.userAgent;

    // If this is an iOS device
    if (/(iPad|iPhone|iPod)/g.test(nUA)) {
        browserDetection.iOS = {};
    }

    if (/(Windows Phone|iemobile|WPDesktop)/gi.test(nUA)) {
        browserDetection.ieMobile = {};
    }

    if (/Safari/.test(nUA)) {
        browserDetection.safari = {};
    }

    if (/Trident/.test(nUA)) {
        browserDetection.ie = {};
    }

    if (/Edge/.test(nUA)) {
        browserDetection.edge = {};
    }
}

export function isTouchDevice() {
    return document.documentElement.classList.contains('touchevents');
}

export function findParentByTagName(el, tagName) {
    let parent = el;

    while (parent !== null && parent.tagName !== tagName.toUpperCase()) {
        parent = parent.parentNode;
    }

    return parent;
}

export function matches(el, selector) {
    let matches =
        document.documentElement.matchesSelector ||
        document.documentElement.webkitMatchesSelector ||
        document.documentElement.mozMatchesSelector ||
        document.documentElement.oMatchesSelector ||
        document.documentElement.msMatchesSelector;

    if (!matches.call(el, selector)) {
        return false;
    }

    return true;
}

export function trackAnchorClicks() {
    /**
     * Internal Links click & page unloading
     **/
    document.addEventListener('click', e => {
        // Get the closest parent anchor element
        let el = findParentByTagName(e.target, 'A');

        // No anchor parent found...
        if (
            typeof el === 'undefined' ||
            el === null ||
            el.tagName !== 'A' ||
            typeof el.href === 'undefined' ||
            el.href === '' ||
            el.classList.contains('js-prevent-page-unload')
        ) {
            return;
        }

        // Handle #hash links differently
        if (el.href.indexOf('#') > -1) {
            let target = document.getElementById(el.hash.substring(1));

            if (target) {
                e.preventDefault();
                autoScrollToElement(target, 200);
            }

            return;
        }

        // Only run unload if we're not using a modifier key like cmd/ctrol or shift as well
        if (e.shiftKey || e.ctrlKey || e.metaKey) {
            return;
        }

        // If the anchor has the target property set don't run unload
        if (
            typeof el.getAttribute('target') !== 'undefined' &&
            el.getAttribute('target') === '_blank'
        ) {
            return;
        }

        // Check that link is internal to site
        if (window.location.hostname === el.hostname) {
            e.preventDefault();

            // Check if this anchor's uri matches a pattern
            // from one of the items in AppPages.pathSegmentMatches
            let uri = el.pathname,
                match = false;

            for (let i = 0; i < AppPages.pathSegmentMatches.length; i++) {
                if (AppPages.pathSegmentMatches[i].test(uri)) {
                    match = true;
                }
            }

            if (match && !browserDetection.ie) {
                // Save existing url to previousUrl
                AppPages.previousUrls.push(window.location.href);

                // Push it
                window.history.pushState(stateObj, null, el.href);

                // Track it in GA
                if (typeof ga !== 'undefined') {
                    ga('send', 'pageview', el.href);
                }

                // Load the page contents
                AppPages.loadPage(el.href);

                return;
            }

            // Normal anchor link to different page
            unloadPage(el.href);
        }
    });
}

export function stringToHTML(str) {
    // If DOMParser is supported, use it
    if (parserSupport()) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(str, 'text/html');
        return doc.body;
    }

    // Otherwise, fallback to old-school method
    var dom = document.createElement('div');
    dom.innerHTML = str;
    return dom;
}

function parserSupport() {
    if (!window.DOMParser) {
        return false;
    }

    var parser = new DOMParser();

    try {
        parser.parseFromString('x', 'text/html');
    } catch (err) {
        return false;
    }

    return true;
}

function windowResize() {
    winW = window.innerWidth;
}

window.addEventListener('resize', () => {
    clearTimeout(winResizeThrottle);

    winResizeThrottle = setTimeout(windowResize, 150);
});
